import type { CheckboxFieldProps } from "$components/inputs";
import { CheckboxField as RHFCheckboxField } from "$components/rhf-fields";
import type { OrderedJSONSchema } from "@elephant-healthcare/yupify";
import React from "react";

interface DynamicCheckboxInputProps extends CheckboxFieldProps {
  fieldDef: OrderedJSONSchema;
  name: string;
}

const DynamicCheckboxInput = ({
  fieldDef: _,
  ...props
}: DynamicCheckboxInputProps): React.ReactElement => (
  <RHFCheckboxField {...props} />
);

export default DynamicCheckboxInput;
